// /enhancers/faq-toggle.js
(function ($) {
    'use strict';

    $('.faq-item-area .accordion').on('show.bs.collapse', function () {
        $(this).closest('.faq-item-area').find('.accordion .show').collapse('hide');
    });
})(jQuery);